module.exports = __webpack_public_path__ + "static/media/menuMusic.84027da0.m4a";